module.exports = __webpack_public_path__ + "img/combine-oper-noti.fa13b7fc.png";